var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.993 3.8q.323-.001.571.255L12.401 9a.72.72 0 0 1 .216.52.73.73 0 0 1-.737.736.77.77 0 0 1-.533-.222L6.993 5.572l-4.355 4.462a.75.75 0 0 1-.533.222.727.727 0 0 1-.73-.736c0-.21.07-.38.21-.52L6.42 4.055a.76.76 0 0 1 .572-.254"
  })));
};
export default SvgChevronUp;